import { useState } from "react";

import type {
  DimensionPropertyNames,
  EventTrackingProviderProps,
} from "@newsela/snitch";

export const MOBILE_APP_MARKER_KEY = "newsela_platform";
export const MOBILE_APP_OS_KEY = "app_os";
export const MOBILE_APP_DEVICE_TYPE_KEY = "app_device_type";

const OS_VALUES = ["ios", "android"] as const satisfies readonly NonNullable<
  DimensionPropertyNames["os"]
>[];
const DEVICE_TYPE_VALUES = [
  "phone",
  "tablet",
] as const satisfies readonly NonNullable<
  DimensionPropertyNames["device_type"]
>[];

type SnitchPlatformInfo = Pick<
  EventTrackingProviderProps,
  "platform" | "defaultDimensionProperties"
>;

const readOneOf = <T extends string>(
  key: string,
  allowed: readonly T[],
): T | undefined => {
  const value = window.localStorage.getItem(key);
  return allowed.find((candidate) => candidate === value);
};

const readPlatform = (): SnitchPlatformInfo => {
  try {
    if (window.localStorage.getItem(MOBILE_APP_MARKER_KEY) === null) {
      return { platform: "lyceum" };
    }
    const os = readOneOf(MOBILE_APP_OS_KEY, OS_VALUES);
    const deviceType = readOneOf(
      MOBILE_APP_DEVICE_TYPE_KEY,
      DEVICE_TYPE_VALUES,
    );
    return {
      platform: "mobile_app",
      defaultDimensionProperties: {
        ...(os && { os }),
        ...(deviceType && { device_type: deviceType }),
      },
    };
  } catch {
    return { platform: "lyceum" };
  }
};

export const useSnitchPlatform = (): SnitchPlatformInfo => {
  const [info] = useState(readPlatform);
  return info;
};
